import React, { useState, useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isNull from 'lodash/isNull';
import { shallowEqual, useSelector } from 'react-redux';
import { initTracking } from '../../utils/trackingUtil';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { getUserBandwidth } from '../../utils/helperFunction';

export default function RouteChangeTracking({ location, trackChangeRoute }) {
  const {
    assessmentId,
    assessmentType,
    loggedinUserEmailId,
    testName,
    testSlug,
  } = useSelector(
    state => ({
      assessmentId: state.assessment.assessmentId,
      assessmentType: state.assessment.assessmentType,
      loggedinUserEmailId: state.auth.initUserDetails.email,
      testName: state?.test?.name,
      testSlug: state?.test?.slug,
    }),
    shallowEqual
  );
  const [trackRoute, setTrackRoute] = useState({
    previous: {},
    current: {},
  });

  /**
   * Capture route change and update it in state
   */
  useEffect(() => {
    const { current } = trackRoute;
    const params = location.pathname ? location.pathname.split('/') : [];
    const problemSlug = params[4];
    const newRoute = {
      current: {
        route: location.pathname,
        params: {
          testSlug: params[2],
          problemSlug,
        },
      },
    };
    if (!_isNull(current)) newRoute.previous = { ...current };
    /**
     * Saving the route change
     */
    setTrackRoute(newRoute);
    /**
     * Triggering the tracking event
     */
    if (
      !_isEmpty(newRoute.current.route) ||
      !_isEmpty(newRoute.previous.route)
    ) {
      trackChangeRoute({
        to_state: newRoute.current.route,
        to_params: newRoute.current.params,
        from_state: newRoute.previous.route ? newRoute.previous.route : '',
        from_params: newRoute.previous.params ? newRoute.previous.params : '',
      });
    }
    /* eslint-disable-next-line */
  }, [location]);

  useUpdateEffect(async () => {
    const bandwidth = await getUserBandwidth();
    const keyNames = {
      assessmentId,
      assessmentType,
      loggedinUserEmailId,
      testSlug,
      testName,
      bandwidth,
    };
    const mainParams = {};
    initTracking(mainParams, keyNames);
  }, [assessmentId, assessmentType, loggedinUserEmailId, testSlug, testName]);

  return <></>;
}
